import React, { useState, useEffect, useCallback } from "react";
import "../../css/Slider.css";

// IMPORT ALL IMAGES (src/assets)
import img1 from "../../../assets/mobile-app/Catalog-1.png";
import img2 from "../../../assets/mobile-app/Catalog-2.png";
import img3 from "../../../assets/mobile-app/Catalog-3.png";
import img4 from "../../../assets/mobile-app/Catalog-4.jfif";
import img5 from "../../../assets/mobile-app/Catalog-5.jfif";
import img6 from "../../../assets/mobile-app/Catalog-6.jfif";
import img7 from "../../../assets/mobile-app/Catalog-7.jfif";
import img8 from "../../../assets/mobile-app/Catalog-8.jfif";
import img9 from "../../../assets/mobile-app/Catalog-9.jfif";

import googlePlay from "../../../assets/google-play.png";
import appStore from "../../../assets/app-store.png";

function Slider() {
  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9];

  const [current, setCurrent] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);

  const maxIndex = images.length - 1;

  const nextSlide = useCallback(() => {
    setCurrent((prev) => (prev >= maxIndex ? 0 : prev + 1));
  }, [maxIndex]);

  // responsive
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSlidesToShow(1);
      } else {
        setSlidesToShow(3);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // auto slide
  useEffect(() => {
    const interval = setInterval(nextSlide, 3000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  return (
    <>
      {/* SLIDER */}
      <div className="slider-container">
        <div className="slider-wrapper">

          {Array.from({ length: slidesToShow }).map((_, i) => {
            const index = (current + i) % images.length;
            const img = images[index];

            return (
              <div key={index} className="slide">
                <img src={img} alt={`slide-${index}`} />
              </div>
            );
          })}

        </div>

        {/* DOTS */}
        <div className="dots">
          {images.map((_, idx) => (
            <span
              key={idx}
              className={`dot ${idx === current ? "active" : ""}`}
              onClick={() => setCurrent(idx)}
            />
          ))}
        </div>
      </div>

      {/* DOWNLOAD SECTION */}
      <section className="download-section">

        <h2>
          Download <span>Froth TestOps</span> Mobile App
        </h2>

        <div className="store-buttons">

          <a
            href="https://play.google.com/store/apps/details?id=ytlc.frothtestops.com.testops"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={googlePlay} alt="Google Play" />
          </a>

          <a
            href="https://apps.apple.com/in/app/frothtestops/id6746042634"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={appStore} alt="App Store" />
          </a>

        </div>
      </section>
    </>
  );
}

export default Slider;